import { useEffect } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import Navbar from '@/components/Navbar';
import { WipeProvider } from '@/components/Wipe';
import MusicPlayer from '@/components/MusicPlayer';
import Home from '@/pages/Home';
import Genesis from '@/pages/Genesis';
import Context from '@/pages/Context';
import Discovery from '@/pages/Discovery';
import Synthesize from '@/pages/Synthesize';
import Resolution from '@/pages/Resolution';
import Saarthi from '@/pages/Saarthi';
import Author from '@/pages/Author';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const PAGE_META = {
  '/': { t: "Designing for the Next Phase of India's Offline Retail · Aditya Ranka", img: 'home' },
  '/chapter/genesis': { t: '01 Genesis · India\'s Offline Retail', img: 'genesis' },
  '/chapter/context': { t: '02 Context · India\'s Offline Retail', img: 'context' },
  '/chapter/discovery': { t: '03 Discovery · India\'s Offline Retail', img: 'discovery' },
  '/chapter/synthesize': { t: '04 Synthesize · India\'s Offline Retail', img: 'synthesize' },
  '/chapter/resolution': { t: '05 Resolution · India\'s Offline Retail', img: 'resolution' },
  '/saarthi': { t: 'Retail Saarthi · A Conceptual Case Study', img: 'saarthi' },
  '/about': { t: 'Aditya Ranka · The Author', img: 'about' },
};

const MetaUpdater = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const m = PAGE_META[pathname] || PAGE_META['/'];
    document.title = m.t;
    const img = `${process.env.REACT_APP_BACKEND_URL}/assets/og/${m.img}.png`;
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', m.t);
    document.querySelector('meta[property="og:image"]')?.setAttribute('content', img);
    document.querySelector('meta[name="twitter:title"]')?.setAttribute('content', m.t);
    document.querySelector('meta[name="twitter:image"]')?.setAttribute('content', img);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollToTop />
        <MetaUpdater />
        <WipeProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/chapter/genesis" element={<Genesis />} />
            <Route path="/chapter/context" element={<Context />} />
            <Route path="/chapter/discovery" element={<Discovery />} />
            <Route path="/chapter/synthesize" element={<Synthesize />} />
            <Route path="/chapter/resolution" element={<Resolution />} />
            <Route path="/saarthi" element={<Saarthi />} />
            <Route path="/about" element={<Author />} />
            <Route path="*" element={<Home />} />
          </Routes>
          <MusicPlayer />
        </WipeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
